import { useCallback } from 'react';
import { Toaster as Sonner, toast } from 'sonner';
import { useTheme } from '@/lib/theme-provider';
import useIsMobile from '@/hooks/use-is-mobile';

export function Toaster(props) {
  const { theme } = useTheme();
  const isMobile = useIsMobile();

  const handleClick = useCallback((e) => {
    const toastEl = e.target.closest('[data-sonner-toast]');
    if (!toastEl) return;

    // Don't auto-dismiss if the toast has an action button
    const hasAction = toastEl.querySelector('[data-button]');
    if (hasAction) return;

    toast.dismiss(toastEl.dataset.sonnerToast);
  }, []);

  // Toasts appear at top on all viewports — below the last sticky element per layout
  const position = 'top-center';
  const desktopOffset = {
    top: 'calc(3rem + var(--tab-nav-h, 0px) + var(--page-sticky-h, 0px) + 0.5rem)',
  };
  const mobileTop =
    'calc(2.5rem + env(safe-area-inset-top) + var(--mobile-tab-nav-h, 0px) + var(--search-bar-h, 0px) + var(--page-sticky-h, 0px) + 0.5rem)';
  const offset = isMobile ? { top: mobileTop } : desktopOffset;
  const mobileOffset = { top: mobileTop };

  return (
    <div onClick={handleClick} onTouchEnd={handleClick}>
      <Sonner
        theme={theme === 'system' ? 'system' : theme}
        position={position}
        offset={offset}
        mobileOffset={mobileOffset}
        className="toaster group"
        toastOptions={{
          classNames: {
            toast:
              'group toast cursor-pointer group-[.toaster]:border-border/50 group-[.toaster]:shadow-lg group-[.toaster]:text-foreground',
            description: 'group-[.toast]:text-muted-foreground',
            actionButton:
              'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
            cancelButton:
              'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
            icon: 'group-[.toast]:opacity-50',
          },
          style: {
            // Solid, non-blurred surface. A `backdrop-filter` here forced
            // mobile WebKit to recomposite the whole page as the toast slid in,
            // briefly BLANKING the content painted behind it — the Bible reader
            // lost its top rows of text the instant a "Link copied" toast
            // appeared (real-device only; desktop compositors don't reproduce
            // it). Dropping the blur removes the hazard. The frosted-glass look
            // still lives on the `.glass` / `.glass-nav` utilities.
            background: 'var(--popover)',
          },
        }}
        {...props}
      />
    </div>
  );
}
